import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { addUpdateSettings } from "../../../store/actions";

import OurModal from "../../../components/ourModal";

export const SaveViewModal = (props) => {
  const { isEdit, view, saveTurnoverView } = props;
  const [state, setState] = useState({
    name: "",
    description: "",
    isDefault: false
  });

  useEffect(() => {
    if (isEdit) {
      setState({ ...view });
    }
  }, [props]);




  const handleChange = (event) => {
    const { value, name } = event.target;
    setState((preValue) => {
      return {
        ...preValue,
        [name]: value,
      };
    });
  };

  const handleChangeCheck = (event) => {
    const { checked, name } = event.target;
    setState((preValue) => {
      return {
        ...preValue,
        [name]: checked,
      };
    });
  };


  function onClose() {
    setState({});
    return props.onClose();
  }

  return (
    <>
      {props.show && (
        <OurModal
          size="small"
          onClose={onClose}
          title={isEdit ? "Edit view" : "Save view"}
          saveBtnText={isEdit ? "Update" : "Save"}
          onSave={() => {
            saveTurnoverView(state);
            setState({ name: "", description: "", isDefault: false });
          }}
        >
          <div className="input-group">
            <div className="input-group-row">
              <label htmlFor="name">View name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={state.name}
                onChange={handleChange}
              />
            </div>
            <div className="input-group-row">
              <label htmlFor="description">Description</label>
              <textarea
                id="description"
                name="description"
                rows="4"
                value={state.description}
                onChange={handleChange}
              />
            </div>
            <div className="input-group-row">
              <label htmlFor="isDefault">
                <input
                  type="checkbox"
                  id="isDefault"
                  name="isDefault"
                  checked={state.isDefault}
                  onChange={handleChangeCheck}
                />
                Set as default
              </label>
            </div>
          </div>
        </OurModal>
      )}
    </>
  );
};

const mapStateToProps = ({
  CompanyEinsReducer,
  CostCenterReducer,
  DeductionCodesReducer,
  DeductionSchedulesReducer,
  PayPeriodProfilesReducer,
}) => {
  const { COST_CENTERS, PARENT_COST_CENTERS } = CostCenterReducer;
  return {
    CompanyEinsReducer,
    COST_CENTERS,
    PARENT_COST_CENTERS,
    DeductionSchedulesReducer,
    DeductionCodesReducer,
    PayPeriodProfilesReducer,
  };
};
export default connect(mapStateToProps, {
  addUpdateSettings,
})(SaveViewModal);
